var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app_wrap"},[_c('div',{staticClass:"bg"}),_vm._v(" "),_c('div',{staticClass:"slideArea"},[_c('p',{staticClass:"text"},[_vm._v("请您完成以下验证，验证成功后可继续探索小猪。")]),_vm._v(" "),(_vm.checkType === 'yidun')?_c('safeVerify',{ref:"netEaseVerify",staticClass:"safeCheck",attrs:{"checkPass":_vm.checkPass()}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f8b72e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avoidSpider.vue
// module id = null
// module chunks = 